import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { findDOMNode } from 'react-dom';
import { createObserver, observeElement, unobserveElement } from './observer';
import { shallowCompare, isChildrenWithRef, hasOwnProperty, toString } from './utils';
var observerOptions = ['root', 'rootMargin', 'threshold'];
var observableProps = ['root', 'rootMargin', 'threshold', 'disabled'];
export var getOptions = function getOptions(props) {
  return observerOptions.reduce(function (options, key) {
    var isRootString = key === 'root' && toString.call(props.root) === '[object String]';
    return Object.assign(options, _defineProperty({}, key, isRootString ? document.querySelector(props[key]) : props[key]));
  }, {});
};

var ReactIntersectionObserver =
/** @class */
function () {
  var ReactIntersectionObserver = /*#__PURE__*/function (_React$Component) {
    _inherits(ReactIntersectionObserver, _React$Component);

    var _super = _createSuper(ReactIntersectionObserver);

    function ReactIntersectionObserver() {
      var _this;

      _classCallCheck(this, ReactIntersectionObserver);

      _this = _super.apply(this, arguments);

      _this.handleChange = function (event) {
        _this.props.onChange(event, _this.externalUnobserve);
      };

      _this.handleNode = function (target) {
        var children = _this.props.children;
        /**
         * Forward hijacked ref to user.
         */

        if (isChildrenWithRef(children)) {
          var childenRef = children.ref;

          if (typeof childenRef === 'function') {
            childenRef(target);
          } else if (childenRef && hasOwnProperty.call(childenRef, 'current')) {
            /*
             * The children ref.current is read-only, we aren't allowed to do this, so
             * in future release it has to go away, and the ref shall be
             * forwarded and assigned to a DOM node by the user.
             */
            childenRef.current = target;
          }
        }

        _this.targetNode = undefined;

        if (target) {
          var targetNode = findDOMNode(target);

          if (targetNode && targetNode.nodeType === 1) {
            _this.targetNode = targetNode;
          }
        }
      };

      _this.observe = function () {
        if (_this.props.children == null || _this.props.disabled) {
          return false;
        }

        if (!_this.targetNode) {
          throw new Error("ReactIntersectionObserver: Can't find DOM node in the provided children. Make sure to render at least one DOM node in the tree.");
        }

        _this.observer = createObserver(getOptions(_this.props));
        _this.target = _this.targetNode;
        observeElement(_assertThisInitialized(_this));
        return true;
      };

      _this.unobserve = function (target) {
        unobserveElement(_assertThisInitialized(_this), target);
      };

      _this.externalUnobserve = function () {
        if (_this.targetNode) {
          _this.unobserve(_this.targetNode);
        }
      };

      return _this;
    }

    _createClass(ReactIntersectionObserver, [{
      key: "getSnapshotBeforeUpdate",
      value: function getSnapshotBeforeUpdate(prevProps) {
        var _this2 = this;

        this.prevTargetNode = this.targetNode;
        var relatedPropsChanged = observableProps.some(function (prop) {
          return shallowCompare(_this2.props[prop], prevProps[prop]);
        });

        if (relatedPropsChanged) {
          if (this.prevTargetNode) {
            if (!prevProps.disabled) {
              this.unobserve(this.prevTargetNode);
            }
          }
        }

        return relatedPropsChanged;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(_, __, relatedPropsChanged) {
        var targetNodeChanged = false; // check if we didn't unobserve previously due to a prop change

        if (!relatedPropsChanged) {
          targetNodeChanged = this.prevTargetNode !== this.targetNode; // check we have a previous node we want to unobserve

          if (targetNodeChanged && this.prevTargetNode != null) {
            this.unobserve(this.prevTargetNode);
          }
        }

        if (relatedPropsChanged || targetNodeChanged) {
          this.observe();
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.observe();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.targetNode) {
          this.unobserve(this.targetNode);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var children = this.props.children;
        return children != null ? React.cloneElement(React.Children.only(children), {
          ref: this.handleNode
        }) : null;
      }
    }]);

    return ReactIntersectionObserver;
  }(React.Component);

  ReactIntersectionObserver.displayName = 'IntersectionObserver';
  return ReactIntersectionObserver;
}();

export default ReactIntersectionObserver;